module.exports = __webpack_public_path__ + "img/help-starting-page.1ffcad69.webp";